import { useEffect } from 'react';

const OAuthCallback = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const connected = params.get('calendar_connected');
    const provider = params.get('provider');

    console.log('🔍 OAuth callback params:', { connected, provider, hasOpener: !!window.opener });

    if (connected === '1' && provider) {
      // Send message to parent window if it exists
      if (window.opener && !window.opener.closed) {
        console.log('📤 Sending success message to parent');
        window.opener.postMessage({
          type: 'OAUTH_SUCCESS',
          provider: provider
        }, window.location.origin);
      }
      
      // Auto-close after 2 seconds
      setTimeout(() => {
        console.log('🔚 Auto-closing popup');
        window.close();
      }, 2000);
    }
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh', 
      fontFamily: 'sans-serif',
      gap: '20px'
    }}>
      <h2>✅ Calendar Connected!</h2>
      <p>This window will close automatically...</p>
      <button 
        onClick={() => window.close()}
        style={{
          padding: '10px 20px',
          fontSize: '16px',
          cursor: 'pointer',
          backgroundColor: '#6366f1',
          color: 'white',
          border: 'none',
          borderRadius: '6px'
        }}
      >
        Close Now
      </button>
    </div>
  );
};

export default OAuthCallback;